import React, { useContext, useRef } from 'react'
import API from '../../../../services/API'
import Box from '@mui/material/Box'
import AmbulanceIcon from '../../../../assets/icons/Ambulance'
import { Avatar, Paper, Tooltip } from '@mui/material'
import imageConverter from '../../../../helpers/imageConverter'
import { GlobalContext } from '../../../../App'

const VehicleImage = ({ imageKey, vehicleID, loadVehicle, height = 128 }) => {
  const imageFileInput = useRef()
  const { setToast } = useContext(GlobalContext)

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0]
    const image = await imageConverter(file)
    API.put('/fleet/' + vehicleID, {
      image: image,
    }).then((res) => {
      if (res.status === 200) {
        setToast({ message: 'Image Updated' })
        loadVehicle()
      }
    })
  }

  return (
    <Tooltip title="Click to change Image">
      <Box>
        <Avatar
          src={imageKey}
          sx={{
            borderRadius: 2,
            width: '100%',
            height,
            zIndex: 1,
            cursor: 'pointer',
          }}
          component={Paper}
          variant="outlined"
          onClick={() => imageFileInput.current.click()}
        >
          <AmbulanceIcon width="100%" height="100%" />
        </Avatar>
        <input
          ref={imageFileInput}
          type="file"
          style={{ display: 'none' }}
          onChange={handlePhotoChange}
          accept="image/*"
        />
      </Box>
    </Tooltip>
  )
}

export default VehicleImage
